import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=2d03affe&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports